export const contentTableConfig = {
  title: '业务员每日新资源电话沟通情况',
  propList: [
    {prop: 'unionid', label: '客户unionid', minWidth: '80'},
    {prop: 'custId', label: '客户ID', minWidth: '80'},
    {prop: 'custName', label: '客户姓名', minWidth: '80'},
    {prop: 'sourceLabel', label: '来源渠道', minWidth: '80'},
    {prop: 'thirdParty', label: '所属第三方', minWidth: '80'},
    {prop: 'firstCreatedAt', label: '客户第一次加入时间', minWidth: '130'},
    {prop: 'corpId', label: '主体ID', minWidth: '80'},
    {prop: 'corpName', label: '主体名称', minWidth: '80'},
    {prop: 'empId', label: '业务员ID', minWidth: '80'},
    {prop: 'empName', label: '业务员姓名', minWidth: '80'},
    {prop: 'contactDeadline', label: '联系截止时间', minWidth: '120',},
    {prop: 'isPhoneCommunicationStr', label: '是否电话沟通', minWidth: '60'},
    {prop: 'empCreatedAt', label: '业务员加入时间', minWidth: '120'},
    {prop: 'lastMonthSalesAmount', label: '业务员上月的业绩', minWidth: '80'},
    {prop: 'lastMonthSalesFlagStr', label: '上月业绩是否达标', minWidth: '80'},
    {prop: 'firstCreatedAtSalesAmount', label: '客户加入当日的业绩', minWidth: '80'},
    {prop: 'contactDeadlineSalesAmount', label: '联系截止日的业绩', minWidth: '80'},
  ],
  childrenProps: {
    rowStyle: changRed,
  },
  showIndexColumn: false,
  showSelectColumn: false
}

function changRed({ row }: { row: any }) {
  if (row.lastMonthSalesFlagStr == "否") { // 变颜色的条件
		return {
		   color: "red"  // 这个return的就是样式 可以是color 也可以是backgroundColor
		}
	}
}
